export default {
  title: 'Fleet Management',
  subtitle: 'Manage and track vehicles',
  
  // List view
  list: {
    addVehicle: 'New Vehicle',
    firstVehicle: 'Add First Vehicle',
    noVehicles: 'No Vehicles',
    noResults: 'No vehicles match your search',
    startAdding: 'Start adding vehicles to your fleet',
    resultsCount: 'vehicles found',
    search: 'Search by license plate, make, model or owner...',
    allStatuses: 'All Statuses',
  },

  // Table columns
  columns: {
    licensePlate: 'License Plate',
    vehicle: 'Vehicle',
    mileage: 'Mileage',
    owner: 'Owner',
    status: 'Status',
    actions: 'Actions',
  },

  // Actions
  actions: {
    view: 'Details',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Are you sure you want to delete vehicle {{licensePlate}}?',
  },

  // Status
  status: {
    active: 'Active',
    inactive: 'Inactive',
    maintenance: 'Maintenance',
    sold: 'Sold',
  },

  // Form
  form: {
    titleNew: 'New Vehicle',
    titleEdit: 'Edit Vehicle',
    
    // Sections
    sections: {
      basicInfo: 'Basic Information',
      technicalData: 'Technical Data',
    },

    // Fields
    fields: {
      licensePlate: 'License Plate',
      licensePlatePlaceholder: 'ABC-123',
      status: 'Status',
      make: 'Make',
      makePlaceholder: 'Toyota, BMW, Mercedes...',
      model: 'Model',
      modelPlaceholder: 'Corolla, X5, E-Class...',
      year: 'Year',
      fuelType: 'Fuel Type',
      mileage: 'Mileage (optional)',
      mileagePlaceholder: 'Can be added later',
      mileageHelp: 'You can add mileage later when recording service or expenses',
      color: 'Color',
      colorPlaceholder: 'Black, White, Red...',
      vin: 'VIN',
      vinPlaceholder: 'WVWZZZ1JZXW123456',
      registrationNumber: 'Registration Number',
      registrationNumberPlaceholder: 'AB-123456',
      vehicleLogbookNumber: 'Vehicle Logbook Number',
      vehicleLogbookNumberPlaceholder: '123456',
      ownerOrganization: 'Owner Organization',
      ownerOrganizationHelp: 'Select an organization from CRM',
      ownerOrganizationNone: '-- None Selected --',
      ownerName: 'Owner Name (if not CRM client)',
      ownerNamePlaceholder: 'Full owner name',
      ownerNameHelp: 'If the owner is not a CRM organization',
      engineCapacity: 'Engine Capacity (cm³)',
      power: 'Power (kW)',
      seats: 'Seats',
      hasTowbar: 'Towbar',
      purchasePrice: 'Purchase Price (HUF)',
      notes: 'Notes',
    },

    // Fuel types
    fuelTypes: {
      gasoline: 'Gasoline',
      diesel: 'Diesel',
      electric: 'Electric',
      hybrid: 'Hybrid',
      lpg: 'LPG',
      cng: 'CNG',
    },

    // Buttons
    buttons: {
      cancel: 'Cancel',
      save: 'Saving...',
      create: 'Create',
      update: 'Update',
    },
  },

  // Messages
  messages: {
    created: 'Vehicle created',
    updated: 'Vehicle updated',
    deleted: 'Vehicle deleted',
    error: 'Error',
    deleteWarning: 'This action cannot be undone.',
  },
};
